import { UI_PRIMITIVE__checkbox } from '@/components/ui/UI_PRIMITIVE__checkbox';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_generation, use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { PLACEHOLDER_bar_line } from '@/pages/_base/views/PLACEHOLDER_bar_line';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { assert_equal } from '@shared/asserts/utils_asserts';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { FIELD_PRIMITIVE__bool } from '@shared/dto/generation/graph_invoke/_fields/_primitives/FIELD_PRIMITIVE__bool';
import { useState } from 'react';

interface PROPS {
  field: FIELD_PRIMITIVE__bool;
}

export function G_UI_FIELD_PRIMITIVE__bool_checkbox({ field }: PROPS) {
  /*
   * STORE
   */

  const { generation_current } = use_slice_generation(['generation_current']);
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);
  let { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  /*
   * STATE
   */

  const [value, set_value] = useState(field.get_value());

  /*
   * EFFECTS
   */
  use_effect(() => set_value(field.get_value()), [field.value]);

  /*
   * EVENTS
   */

  async function onCheckedChange(checked: boolean) {
    if (checked == field.get_value()) return;

    assert_equal(field.meta.graph_id, generation_current.tool.graph.meta.graph_id);

    let field_new = field.clone({ value: checked });

    await UTILS__graph_data.update_field(generation_current.tool.graph, field_new);
  }

  /*
   * METHODS
   */

  function is_disabled() {
    return g_general__ui_disabled;
  }

  function get_cursor() {
    return is_disabled() ? 'cursor-not-allowed' : 'cursor-pointer';
  }

  /*
   * HTML
   */

  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_GENERATION_UPDATE)) return <PLACEHOLDER_bar_line />;

  return (
    <div
      className={`flex flex-row items-center gap-2
    ${get_cursor()}
    `}
    >
      <UI_PRIMITIVE__checkbox id={field.meta.field_id} checked={value} {...{ onCheckedChange }} disabled={is_disabled()} />

      <label
        htmlFor={field.meta.field_id}
        className={`ml-2 text-sm text-bar-foreground 
            ${value ? '' : 'opacity-50'} 
            ${get_cursor()}
         `}
      >
        {value ? 'Yes' : 'No'}
      </label>
    </div>
  );
}
